<template>
  <el-card style="min-height: 45rem">
    <el-table :data="list">
      <el-table-column prop="id" label="编号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="fee" label="划转金额" show-overflow-tooltip></el-table-column>
      <el-table-column prop="scale" label="划转比例" show-overflow-tooltip></el-table-column>
      <el-table-column prop="order_id" label="来源订单编号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="uid" label="来源用户编号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="u_nickname" label="来源用户昵称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="u_phone" label="来源用户手机" show-overflow-tooltip></el-table-column>
      <el-table-column prop="created_at" label="时间" show-overflow-tooltip>
        <template v-slot="s">{{s.row.created_at | date}}</template>
      </el-table-column>
      <template #append>
        <el-pagination style="padding: .5rem" background layout="total,prev, pager,next"
                       :total="total" :page-size="15" :current-page="page" @current-change="pageChange">
        </el-pagination>
      </template>
    </el-table>
  </el-card>
</template>

<script>

export default {
  name: "PoolGetLog",
  data(){
    return{
      list:[],
      page:1,
      total:0,
    }
  },
  mounted() {
    this.load();
  },
  methods:{
    pageChange(e){
      this.page = e;
      this.load();
    },
    load(){
      this.$u.api.shop.plugin.capital.poolGetLog({page:this.page}).then(res=>{
        this.list = res.list;
        this.total = res.total;
      })
    },
  },
}
</script>

<style scoped>

</style>